import PropTypes, { string } from "prop-types";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { LineWeight } from "@mui/icons-material";
import "./promo.css";
const NavMenu = ({ strings, userData }) => {
  ////console.log(strings);
  const history = useHistory();
  const location = window.location.pathname;
  const [showMenuArticoli, setShowMenuArticoli] = useState(false);
  const [showMenuCollezioni, setShowMenuCollezioni] = useState(false);

  const resetQuerySearch = (_where) => {
    //sessionStorage.setItem("filter", JSON.stringify({}))   DA ABILITARE SE VUOLE RESETTARE TUTTI I FILTRI

    sessionStorage.setItem("filter", JSON.stringify({}));
    //setSortValues({})
    //setRefresh(!refresh)
    //history.push("/")
    //setTimeout(() => history.push(process.env.PUBLIC_URL + "/shop-grid-full-width"), 10);
    //sessionStorage.setItem("currentPage", 1)

    localStorage.setItem("currentPage", 1);
    setTimeout(() => history.push("/"), 50);
    setTimeout(() => history.push(process.env.PUBLIC_URL + _where), 100);

    //}
  };

  const getColor = (loc) => {
    return location === "/" + loc ? "lightblue" : "white";
  };
  const handleMouseEnterArticoli = () => {
    setShowMenuArticoli(true);
  };

  const handleMouseLeaveArticoli = () => {
    setShowMenuArticoli(false);
  };

  const handleMouseEnterCollezioni = () => {
    setShowMenuCollezioni(true);
  };

  const handleMouseLeaveCollezioni = () => {
    setShowMenuCollezioni(false);
  };
  return (
    <div className="main-menu">
      <nav>
        <ul style={{ textAlign: "left" }}>
          {!(
            userData?.user?.user &&
            (userData?.user?.user?.IDCli || userData?.user?.user?.IDAge)
          ) && (
            <li>
              <Link
                to={process.env.PUBLIC_URL + "/login"}
                style={{ lineHeight: "68px" }}
              >
                {"Login"}
              </Link>
            </li>
          )}

          {global.aziendaID == 1 || global.aziendaID == 4 ? (
            <li>
              <Link
                onClick={() => resetQuerySearch("/shop-grid-full-width?name=")}
                to={process.env.PUBLIC_URL + "/shop-grid-full-width"}
                style={{
                  lineHeight: "68px",
                  color: getColor("shop-grid-full-width"),
                }}
              >
                {userData?.user?.user?.IDCli || userData?.user?.user?.IDAge
                  ? "Acquisti"
                  : "Prodotti"}
              </Link>
            </li>
          ) : null}
          {global.aziendaID == 4 &&
          (userData?.user?.user?.IDCli || userData?.user?.user?.IDAge) ? (
            <li>
              <Link
                onClick={() => resetQuerySearch("/my-last-purchases")}
                to={process.env.PUBLIC_URL + "/my-last-purchases"}
                style={{
                  lineHeight: "68px",
                  color: getColor("my-last-purchases"),
                }}
              >
                {"Storico acquisti"}
              </Link>
            </li>
          ) : null}
          {global.aziendaID == 3 ? (
            <div
              onMouseEnter={handleMouseEnterArticoli}
              onMouseLeave={handleMouseLeaveArticoli}
              style={{ display: "inline-block", position: "relative" }}
            >
              <li>
                <Link
                  onClick={() =>
                    resetQuerySearch("/shop-grid-full-width?name=")
                  }
                  to={process.env.PUBLIC_URL + "/shop-grid-full-width"}
                  style={{
                    lineHeight: "68px",
                    color: getColor("shop-grid-full-width"),
                  }}
                >
                  {"Articoli"}
                </Link>
              </li>
              {showMenuArticoli && (
                <div
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: 0,
                    background: "#f0f0f0",
                    padding: "10px",
                    borderRadius: "5px",
                    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                    display: "flex", // Affianca le sezioni orizzontalmente
                    gap: "50px", // Spazio tra le sezioni
                    flexDirection: "row",
                    zIndex: 1, // Assicura che il menu sia sopra altri elementi
                    whiteSpace: "nowrap", // Evita la rottura del testo e permette l'adattamento al contenuto
                    animation: "slideDown 0.3s ease-in-out", // Applica l'animazione di discesa
                  }}
                >
                  {/* Prima Sezione */}
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <h5>
                      <b>Abbigliamento</b>
                    </h5>
                    <Link>Opzione 1</Link>
                    <Link>Opzione 2</Link>
                  </div>

                  {/* Seconda Sezione */}
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <h5>
                      <b>Accessori</b>
                    </h5>
                    <Link>Opzione 1</Link>
                    <Link>Opzione 2</Link>
                  </div>
                  <style>
                    {`
          @keyframes slideDown {
            from {
              opacity: 0;
              transform: translateY(-10px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
                  </style>
                </div>
              )}
            </div>
          ) : null}

          {global.aziendaID == 3 ? (
            <div
              onMouseEnter={handleMouseEnterCollezioni}
              onMouseLeave={handleMouseLeaveCollezioni}
              style={{ display: "inline-block", position: "relative" }}
            >
              <li>
                <Link
                  onClick={() =>
                    resetQuerySearch("/shop-grid-full-width?name=")
                  }
                  to={process.env.PUBLIC_URL + "/shop-grid-full-width"}
                  style={{
                    lineHeight: "68px",
                    color: getColor("shop-grid-full-width"),
                  }}
                >
                  {"Collezioni"}
                </Link>
              </li>
              {showMenuCollezioni && (
                <div
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: 0,
                    background: "#f0f0f0",
                    padding: "10px",
                    borderRadius: "5px",
                    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                    display: "flex", // Affianca le sezioni orizzontalmente
                    gap: "50px", // Spazio tra le sezioni
                    flexDirection: "row",
                    zIndex: 1, // Assicura che il menu sia sopra altri elementi
                    whiteSpace: "nowrap", // Evita la rottura del testo e permette l'adattamento al contenuto
                    animation: "slideDown 0.3s ease-in-out", // Applica l'animazione di discesa
                  }}
                >
                  {/* Prima Sezione */}
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <Link>Opzione 1</Link>
                    <Link>Opzione 2</Link>
                  </div>
                  <style>
                    {`
          @keyframes slideDown {
            from {
              opacity: 0;
              transform: translateY(-10px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
                  </style>
                </div>
              )}
            </div>
          ) : null}

          {global.aziendaID == 2 &&
          (userData?.user?.user?.IDCli || userData?.user?.user?.IDAge) ? (
            <li>
              <Link
                onClick={() => {
                  localStorage.setItem("promo", "NO");
                  resetQuerySearch("/shop-grid-full-width");
                }}
                to={process.env.PUBLIC_URL + "/shop-grid-full-width"}
                style={{ lineHeight: "68px" }}
              >
                {"Home"}
              </Link>
            </li>
          ) : null}
          {global.aziendaID == 2 &&
          (userData?.user?.user?.IDCli || userData?.user?.user?.IDAge) &&
          userData.user.user?.showPromo == 1 ? (
            <li>
              <Link
                className="blink-1"
                onClick={() => {
                  localStorage.setItem("promo", "SI");
                  resetQuerySearch("/shop-grid-full-width");
                }}
                to={process.env.PUBLIC_URL + "/shop-grid-full-width"}
                style={{ lineHeight: "68px" }}
              >
                {"Promo"}
              </Link>
            </li>
          ) : null}
          {userData?.user?.user &&
          (userData?.user?.user?.IDCli || userData?.user?.user?.IDAge) &&
          global.aziendaID == 1 ? (
            <li>
              <Link
                onClick={() => resetQuerySearch("/consigliati?name=")}
                to={process.env.PUBLIC_URL + "/consigliati"}
                style={{ lineHeight: "68px", color: getColor("consigliati") }}
              >
                {"Consigliati"}
              </Link>
            </li>
          ) : null}

          {global.aziendaID == 1 || global.aziendaID == 3 ? (
            <li>
              <Link
                to={process.env.PUBLIC_URL + "/CatalogFlip/0"}
                style={{ lineHeight: "68px", color: getColor("CatalogFlip/0") }}
              >
                {strings["catalog"]}
              </Link>
            </li>
          ) : null}

          {userData.user.user &&
          (userData.user.user.IDCli || userData.user.user.IDAge) ? (
            <li>
              {/*<img src="https://media.giphy.com/media/RKKPOi4piK6CUXiUj7/giphy.gif" style={{width:"25%", float:"left", position:"absolute", top:"17%", left:"-5%"}}></img>*/}
              <Link
                to={process.env.PUBLIC_URL + "/my-documents"}
                style={{ lineHeight: "68px", color: getColor("my-documents") }}
              >
                I miei documenti{" "}
              </Link>
            </li>
          ) : null}
          {userData.user.user &&
          (userData.user.user.IDCli || userData.user.user.IDAge) &&
          (global.aziendaID == 1 || global.aziendaID == 3) ? (
            <li>
              <img
                src="https://media.giphy.com/media/RKKPOi4piK6CUXiUj7/giphy.gif"
                style={{
                  width: "40%",
                  float: "left",
                  position: "absolute",
                  top: "17%",
                  left: "-5%",
                }}
              ></img>
              <Link
                to={process.env.PUBLIC_URL + "/shippings"}
                style={{ lineHeight: "68px", color: getColor("shippings") }}
              >
                {strings["shippings"]}
              </Link>
            </li>
          ) : null}
          {userData.user.user &&
          (userData.user.user.IDCli || userData.user.user.IDAge) &&
          (global.aziendaID == 1 || global.aziendaID == 3) ? (
            <li>
              <Link
                to={process.env.PUBLIC_URL + "/my-pricelist"}
                style={{ lineHeight: "68px", color: getColor("my-pricelist") }}
              >
                Listino
              </Link>
            </li>
          ) : null}

          {
            /*userData.user.user?.IDCli === 41917 && */
            userData?.user?.user?.IDCli &&
            window["configPegaso"].untentiModificaBanners?.includes(
              localStorage.getItem("IDDetCliRef")
            ) ? (
              <li>
                <Link
                  to={process.env.PUBLIC_URL + "/personalizzaBanners"}
                  style={{
                    lineHeight: "68px",
                    color: getColor("personalizzaBanners"),
                  }}
                >
                  {"Banners"}
                </Link>
              </li>
            ) : null
          }

          {global.aziendaID == 1 || global.aziendaID == 3 ? (
            <li>
              <Link
                to={process.env.PUBLIC_URL + "/about"}
                style={{ lineHeight: "68px", color: getColor("about") }}
              >
                {"Chi siamo"}
              </Link>
            </li>
          ) : null}

          {global.aziendaID == 1 || global.aziendaID == 3 ? (
            <li>
              <Link
                to={process.env.PUBLIC_URL + "/contact"}
                style={{ lineHeight: "68px", color: getColor("contact") }}
              >
                {strings["contact_us"]}
              </Link>
            </li>
          ) : null}
          {global.aziendaID == 1 || global.aziendaID == 3 ? (
            <li>
              <Link
                to={process.env.PUBLIC_URL + "/tutorial"}
                style={{ lineHeight: "68px", color: getColor("tutorial") }}
              >
                {strings["tutorial"]}
              </Link>
            </li>
          ) : null}
          {global.aziendaID == 1 || global.aziendaID == 3 ? (
            <li>
              <img
                src="https://media.giphy.com/media/RKKPOi4piK6CUXiUj7/giphy.gif"
                style={{
                  width: "30%",
                  float: "left",
                  position: "absolute",
                  top: "17%",
                  left: "-5%",
                }}
              ></img>
              <Link
                to={process.env.PUBLIC_URL + "/colors"}
                style={{ lineHeight: "68px", color: getColor("colors") }}
              >
                {strings["colours"]}
              </Link>
            </li>
          ) : null}

          {false && (
            <li className="hidden">
              <Link
                to={process.env.PUBLIC_URL + "/blog-standard"}
                style={{ lineHeight: "68px" }}
              >
                {strings["blog"]} <i className="fa fa-angle-down" />
              </Link>
              <ul className="submenu">
                <li>
                  <Link
                    to={process.env.PUBLIC_URL + "/blog-standard"}
                    style={{ lineHeight: "68px" }}
                  >
                    {strings["blog_standard"]}
                  </Link>
                </li>
                <li>
                  <Link
                    to={process.env.PUBLIC_URL + "/blog-no-sidebar"}
                    style={{ lineHeight: "68px" }}
                  >
                    {strings["blog_no_sidebar"]}
                  </Link>
                </li>
                <li>
                  <Link
                    to={process.env.PUBLIC_URL + "/blog-right-sidebar"}
                    style={{ lineHeight: "68px" }}
                  >
                    {strings["blog_right_sidebar"]}
                  </Link>
                </li>
                <li>
                  <Link
                    to={process.env.PUBLIC_URL + "/blog-details-standard"}
                    style={{ lineHeight: "68px" }}
                  >
                    {strings["blog_details_standard"]}
                  </Link>
                </li>
              </ul>
            </li>
          )}
        </ul>
      </nav>
    </div>
  );
};

NavMenu.propTypes = {
  strings: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
  };
};

//export default multilanguage(NavMenu);
//export default NavMenu;
export default connect(mapStateToProps)(NavMenu);
